//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// @ is an alias to /src
import moment from 'moment'
import { mapState } from 'vuex'
export default {
  name: 'VisitList',
  data() {
    return {
      activeIndex: null,
      list: []
    }
  },
  components: {
  },
  computed: mapState({
    user: state => state.user.user
  }),
  mounted() {
    this.getVisits()
  },
  methods: {
    getDate (createdAt) {
      if (!createdAt) {
        return ''
      }
      return moment(createdAt).format('YYYY-MM-DD')
    },
    getVisits () {
      this.$store.httpDispatch({})('getVisits')
      .then((res) => {
        console.log(res)
        if (res.data.code === 0) {
          this.list = res.data.data.visits
        }
      })
    }
  }
}
